import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import "./RegisterUserListAudition.css";
import RegisterUserListTable from "./RegisterUserListTable";
import cup from "../../../../../../../../assets/images/cup 2.png";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

import { serverInfo } from "../../../../../../../../App";
import "./RegisterUserListAudition.css";
import Nodata from "../../../../../../../Reuseable/Nodata";

function RegisterUserListOnlineAudition() {
  const [events, setEvent] = useState({});
  const { imageCdnUrl } = useContext(serverInfo);
  const [buffer, setBuffer] = useState(true);
  const [users, setUsers] = useState([]);
  const [auditionName, setAuditionName] = useState("");
  const [listView, setListView] = useState(false);

  useEffect(() => {
    axios.get("/api/audition-admin/audition/online-round").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvent(res.data.lives);
        setUsers(res.data.lives?.active_round_info?.mark_trackings);
      }
    });
  }, []);

  const clickHandler = (id, name) => {
    setListView(true);
    setAuditionName(name);
  };

  const tableHead = [
    "#SL",
    "Name",
    "Phone",
    "Audition Title",
    "Start - End",
    "Upload Video",
    "Action",
  ];

  return (
    <>
      <AllDataHeader title="Register User List" image={cup} count={"Zero"} />

      {buffer ? (
        <LoaderPost />
      ) : (
        <div className="py-3">
          {/* {events.length !== 0 ? ( */}
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-3 mb-3 p-3">
              <div className="card card-bg completedMeetupBlack ">
                <img
                  src={imageCdnUrl + events?.banner}
                  className="img-fluid p-2 ImgBlue"
                  alt=""
                  style={{
                    height: "200px",
                    width: "100%",
                  }}
                />
                <div className="p-3">
                  <center>
                    <h5 className="text-white text-center title-limit">
                      {events?.title}
                    </h5>

                    <button
                      className="btn btn-warning PTBDn px-5 py-2 mt-4"
                      onClick={() => clickHandler(events?.id, events?.title)}
                    >
                      Show
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
          {/* // ) : ( // <Nodata />
          // )} */}
          {listView && users ? (
            <RegisterUserListTable
              data={users}
              tableHead={tableHead}
              auditionName={auditionName}
              eventEl={events}
            />
          ) : null}
        </div>
      )}
    </>
  );
}

export default RegisterUserListOnlineAudition;
